var _style, _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-rename-this{fill:#D1D1D1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,16.9c-1.8,0-3.5-0.9-4.4-2.6c-1.4-2.4-0.6-5.6,1.9-7c0.7-0.4,1.5-0.6,2.4-0.7c0.1,0,0.2,0,0.3,0.1 c0.2,0.1,0.3,0.5,0.2,0.7c-0.8,1.3-0.8,2.9,0,4.2l0,0c0.7,1.3,2.1,2.1,3.6,2c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0.2,0.3,0.3 c0.1,0.1,0,0.3,0,0.4c-0.5,0.7-1.1,1.3-1.8,1.7C14.1,16.7,13.2,16.9,12.3,16.9z M11.4,7.9C11,8,10.6,8.1,10.3,8.3 c-2,1.1-2.6,3.6-1.5,5.6c1.1,2,3.6,2.6,5.6,1.5c0.3-0.2,0.6-0.4,0.9-0.7c-1.5-0.2-2.8-1.1-3.6-2.5C11,10.9,10.8,9.3,11.4,7.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.1,
    cy: 14.4,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 12.9,
    r: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.5,
    cy: 12.4,
    r: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.45256c4ec7eaf122d5357b6c05e550ad.svg";
export { ForwardRef as ReactComponent };